module.exports = __webpack_public_path__ + "assets/img/10.180f5bc3.png";